module.exports = __webpack_public_path__ + "static/media/CyberLogovo_Main_preview.2472e7e3.jpg";